import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import './PracticeSurveys.css';

function VenezuelaSurvey() {
  // State variables to manage user answers, current question index, and form submission state
  const [answers, setAnswers] = useState({
    capital: '',
    totalArea: '',
    statesCount: '',
    population: '',
    officialCurrency: '',
    largestCity: '',
    continent: '',
    flagStars: '',
    nationalAnthem: '',
    naturalSymbols: '',
    nationalSport: '',
    borderCountries: ''
  });
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [submitted, setSubmitted] = useState(false); // State to track form submission
  const { userDetails } = useAuth(); // Extract the necessary user details using the useAuth hook
  const apiUrl = process.env.REACT_APP_API_BASE_URL;


  // Function to handle input change for each question
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAnswers(prevAnswers => ({
      ...prevAnswers,
      [name]: value
    }));
  };

  // Function to handle moving to the next question
  const handleNextQuestion = () => {
    setCurrentQuestion(prevQuestion => prevQuestion + 1);
  };

  // Function to handle moving to the previous question
  const handlePreviousQuestion = () => {
    setCurrentQuestion(prevQuestion => prevQuestion - 1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const finalScore = calculateScore(answers);
    setSubmitted(true);

    // Ensure that the user is logged in before allowing score submission
    if (!userDetails.email) {
      alert("You must be logged in to submit scores.");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/submit-score`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: userDetails.email, // Use email for score submission
          score: finalScore,
          surveyId: 'VenezuelaSurvey',
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit score');
      }

      alert('Score submitted successfully!');
    } catch (error) {
      console.error('Score submission error:', error);
      alert(error.message);
    }
  };

  const calculateScore = (answers) => {
    let score = 0;
    questions.forEach(question => {
      if (answers[question.id] === question.correctAnswer) {
        score += 10;  // Assuming each correct answer gives 10 points
      }
    });
    return score;
  };

  // Questions data for Venezuela
  const questions = [
    {
      id: 'capital',
      label: 'What\'s the capital of Venezuela?',
      correctAnswer: 'Caracas',
      options: ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto', 'Maracay']
    },
    {
      id: 'totalArea',
      label: 'What is the total area of Venezuela?',
      correctAnswer: '916,445 SquareKM',
      options: ['850,000 SquareKM', '900,000 SquareKM', '916,445 SquareKM', '950,000 SquareKM', '1,000,000 SquareKM']
    },
    {
      id: 'statesCount',
      label: 'How many states does Venezuela have?',
      correctAnswer: '23 states',
      options: ['20 states', '21 states', '22 states', '23 states', '24 states']
    },
    {
      id: 'population',
      label: 'What is the population of Venezuela?',
      correctAnswer: 'Around 30 million',
      options: ['Around 20 million', 'Around 25 million', 'Around 30 million', 'Around 35 million', 'Around 40 million']
    },
    {
      id: 'officialCurrency',
      label: 'What is the official currency of the country?',
      correctAnswer: 'Bolivar Fuerte',
      options: ['Bolivar Fuerte', 'Venezuelan Dollar', 'Peso', 'Bolivar', 'Euro']
    },
    {
      id: 'largestCity',
      label: 'What is the largest city?',
      correctAnswer: 'Caracas',
      options: ['Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto', 'Maracay']
    },
    {
      id: 'continent',
      label: 'In which continent is Venezuela located?',
      correctAnswer: 'South America',
      options: ['North America', 'South America', 'Europe', 'Asia', 'Africa']
    },
    {
      id: 'flagStars',
      label: 'How many stars does the flag of Venezuela have?',
      correctAnswer: '8 stars',
      options: ['6 stars', '7 stars', '8 stars', '9 stars', '10 stars']
    },
    {
      id: 'nationalAnthem',
      label: 'What is the name of the national anthem?',
      correctAnswer: 'Gloria al bravo pueblo',
      options: ['Himno Nacional de Venezuela', 'Gloria al bravo pueblo', 'Patria querida', 'Himno a Bolívar', 'Himno a la Bandera']
    },
    {
      id: 'naturalSymbols',
      label: 'What are the three natural symbols of the country?',
      correctAnswer: 'Turpial, Araguaney and Orchidea',
      options: ['Turpial, Orchidea, Araña', 'Araguaney, Orchidea, Turpial', 'Orchidea, Turpial, Araguaney', 'Araguaney, Turpial, Orquidea', 'Turpial, Araguaney, Orchidea']
    },
    {
      id: 'nationalSport',
      label: 'What is the national sport?',
      correctAnswer: 'Baseball',
      options: ['Football', 'Basketball', 'Baseball', 'Volleyball', 'Tennis']
    },
    {
      id: 'borderCountries',
      label: 'How many countries does Venezuela share borders with, and which are those countries?',
      correctAnswer: 'Colombia, Brazil and Guyana',
      options: ['2 countries: Colombia and Brazil', '3 countries: Colombia, Brazil, and Guyana', '4 countries: Colombia, Brazil, Guyana, and Trinidad and Tobago', '2 countries: Colombia and Guyana', '3 countries: Colombia, Guyana, and Trinidad and Tobago']
    }
  ];

  return (
    <div className="container">
      {!submitted && (
        <div className="card mt-4">
          <div className="surveycard">
            <h2>Venezuela Survey</h2>
          </div>
        </div>
      )}
      {!submitted && (
        <div className="card mt-4">
          <div className="surveycard">
            <form onSubmit={handleSubmit}>
              {/* Display current question */}
              <div>
                <div className="surveyform">
                  <label htmlFor={questions[currentQuestion].id}>{questions[currentQuestion].label}</label>
                  <select
                    className="surveyformcontrol"
                    id={questions[currentQuestion].id}
                    name={questions[currentQuestion].id}
                    value={answers[questions[currentQuestion].id]}
                    onChange={handleInputChange}
                  >
                    <option value="">Select an option</option>
                    {questions[currentQuestion].options.map((option, index) => (
                      <option key={index} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                {/* Hide buttons after form submission */}
                {!submitted && (
                  <div>
                    {/* Next and Previous buttons */}
                    {currentQuestion > 0 && <button type="button" className="surveybuttons" onClick={handlePreviousQuestion}>Previous</button>}
                    {currentQuestion < questions.length - 1 && <button type="button" className="surveybuttons" onClick={handleNextQuestion}>Next</button>}
                    {currentQuestion === questions.length - 1 && <button type="submit" className="surveybuttons">Submit</button>}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
      {/* Display answers after form submission */}
      {submitted && (
        <div className="card mt-4">
          <div className="surveycard">
            <h3 className="surveyanswers">Answers:</h3>
            {questions.map(question => (
              <div key={question.id}>
                <p><strong>{question.label}</strong></p>
                <p>Your answer: {answers[question.id]}</p>
                <p>Correct answer: {question.correctAnswer}</p>
                {/* Add logic here to compare user's answer with correct answer and style accordingly */}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default VenezuelaSurvey;
